module.exports = __webpack_public_path__ + "img/webnew33.25636dca.jpg";